/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Delete_TitleInputs */

const en_admin_invite_codes_delete_title = /** @type {(inputs: Admin_Invite_Codes_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete invite code?`)
};

/**
* | output |
* | --- |
* | "Delete invite code?" |
*
* @param {Admin_Invite_Codes_Delete_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_delete_title = /** @type {((inputs?: Admin_Invite_Codes_Delete_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Delete_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_delete_title(inputs)
});
export { admin_invite_codes_delete_title as "admin.invite_codes.delete_title" }